import { createContext, useMemo } from 'react'
import { getEmployeeFullName } from '../../../../../util/table.util'

export const FormOptionsContext = createContext({})

/**
 * transforms the employees groups array in dropdown options based on the group type
 */
const getGroupOptions = (groups = [], groupType) =>
  groups
    .filter((item) => item.groupType === groupType)
    .map((item) => ({
      value: item.id,
      label: item.name,
    }))
    .sort((a, b) => a?.label?.localeCompare(b?.label))

/**
 * Provides the options for the select/multiselect components modal
 */
const useFormOptions = ({ allEmployees = [], employee = {} }) => {
  const employeeEmailOptions = useMemo(
    () =>
      allEmployees
        .filter((item) => !item.ignored)
        .map((item) => ({ label: `${getEmployeeFullName(item)} (${item.email})`, value: item.email }))
        .sort((a, b) => a?.label?.localeCompare(b?.label)),
    [allEmployees],
  )

  const m365GroupOptions = useMemo(() => getGroupOptions(employee?.groups, 'M365Group'), [employee])

  const securityGroupOptions = useMemo(() => getGroupOptions(employee?.groups, 'SecurityGroup'), [employee])

  const distributionGroupOptions = useMemo(
    () =>
      getGroupOptions(employee?.groups, 'DistributionGroup').concat(
        getGroupOptions(employee?.groups, 'SecurityMailEnabledGroup'),
      ),
    [employee],
  )

  const sharedMailboxOptions = useMemo(() => getGroupOptions(employee?.groups, 'SharedMailbox'), [employee])

  // memoizing here because this is meant to be passed to the FormOptionsContext
  const provided = useMemo(
    () => ({
      employeeEmailOptions,
      m365GroupOptions,
      securityGroupOptions,
      distributionGroupOptions,
      sharedMailboxOptions,
    }),
    [employeeEmailOptions, m365GroupOptions, securityGroupOptions, distributionGroupOptions, sharedMailboxOptions],
  )

  return provided
}

export default useFormOptions
